import { apiContainer } from '@vlabs/api-bindings';

export const estimateFace = async (file) => apiContainer.lunaClient.sdk.estimate(file, {
  estimate_face_descriptor: 1,
  detect_face: 1,
  estimate_face_warp: 1,
});
